import {
  gantt,
  Gantt,
  Identifiable,
  Project,
  Zone,
  zoneProjectsRetrievalFilter,
} from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function flattenProjects(
  projectsChunks: {
    project: Identifiable<Project>;
    zone: Identifiable<Zone>;
  }[],
): Identifiable<Project>[] {
  return projectsChunks.reduce<Identifiable<Project>[]>(
    (projects, chunk) => [...projects, chunk.project],
    [],
  );
}

function flattenGantt(gantts: Gantt[]): Gantt {
  return gantts.reduce<Gantt>(
    (gantt, chunk) => ({
      ...gantts,
      constraints: [...gantt.constraints, ...chunk.constraints],
      projects: [...gantt.projects, ...chunk.projects],
    }),
    gantt,
  );
}

function removeUnPlannedProjects(
  projects: Identifiable<Project>[],
): Identifiable<Project>[] {
  return projects.filter(
    (project) => !!project.rootList.endDate && !!project.rootList.startDate,
  );
}

function createInteractor(repository: Repository): Interactor {
  return (zone) =>
    present(repository.getZoneGantt(zone).then((gantt) => ({ gantt, zone })));
}

export type { Interactor };

export { createInteractor };
